// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3vuNd","footer":"ModalInfo_footer__1NbCw"};